export default __webpack_public_path__ + "static/media/notificationSound.aff388c9.mp3";